import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { Button } from 'monday-ui-react-core'

const ChangeOrganization = ({open, onCancel, onConfirm, newOrganizationName}) => {
    return (
        <>
            <Dialog
                open={open}
                onClose={onCancel}
                fullWidth={false}
                maxWidth='md'
            >
                <DialogTitle>Change Current Organization</DialogTitle>
                <IconButton
                    aria-label='close'
                    onClick={onCancel}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500]
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <DialogContent>
                    <section className="mb-5">
                        <span>Do you want to switch to organization: <b>{newOrganizationName}</b></span>
                    </section>
                </DialogContent>
                <DialogActions>
                    <Button className="cancel" onClick={onCancel} marginRight={2}>No</Button>
                    <Button className="success" onClick={onConfirm} marginRight={2}>Yes</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ChangeOrganization